module.exports = __webpack_public_path__ + "images/emoji/poultry_leg.00f531daa10cea44b135.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/poultry_leg.png
// module id = wLzs
// module chunks = 24